import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import PrivateRoute from './components/PrivateRoute'
import App from './App'
import AdminLayout from './components/layout/AdminLayout'
import Login from './components/Auth/Login'
import ForgotPassword from './components/Auth/ForgotPassword'
import ResetPassword from './components/Auth/ResetPassword'
import AddUser from './components/User/AddUser'
import Users from './components/User/Users'
import UserLayout from './components/layout/UserLayout'
import AdminDashboard from './components/Admin/AdminDashboard'
import Terms from './components/Terms/Terms'
import UserAgreements from './components/Terms/UserAgreements'
import Activities from './components/User/Activities'
import FeedbackList from './components/Feedback/FeedbackList'
import Conversations from './components/Conversation/Conversations'
import Conversation from './components/Conversation/Conversation'
import EditUser from './components/User/EditUser'


function Main() {
    return (
      <>
        
        <Router>
          <Routes>
            <Route path="/user-login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/user-login" replace />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/user-agreements" element={<UserAgreements />} />

            {/* PRIVATE ROUTES */}
            <Route 
              path="/research" 
              element={
                <PrivateRoute>
                  <React.Fragment>
                    <UserLayout>
                      <App />
                    </UserLayout>
                  </React.Fragment>
                </PrivateRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <React.Fragment>
                    <AdminLayout>
                      <AdminDashboard />
                    </AdminLayout>
                  </React.Fragment>
                </PrivateRoute>
              } 
            />

            {/* USERS */}
            <Route 
              path="/admin/users" 
              element={
              <PrivateRoute>
                <React.Fragment>
                <AdminLayout>
                  <Users/>
                </AdminLayout>
                </React.Fragment>
              </PrivateRoute>
              } 
            />

            <Route 
              path="/admin/users/add-user" 
              element={
              <PrivateRoute>
                <React.Fragment>
                <AdminLayout>
                  <AddUser/>
                </AdminLayout>
                </React.Fragment>
              </PrivateRoute>
                } 
            />

            <Route 
                path="/admin/users/edit/:id" 
                element={
              <PrivateRoute>
                <React.Fragment>
                <AdminLayout>
                  <EditUser/>
                </AdminLayout>
                </React.Fragment>
              </PrivateRoute>
              } 
            />

            {/* USER ACTIVITIES */}
            <Route 
                path="/admin/activities" 
                element={
                <PrivateRoute>
                  <React.Fragment>
                  <AdminLayout>
                    <Activities/>
                  </AdminLayout>
                  </React.Fragment>
                </PrivateRoute>
                } 
            />              
              
            {/* USER FEEDBACK */}
            <Route 
                path="/admin/feedback" 
                element={
                <PrivateRoute>
                  <React.Fragment>
                  <AdminLayout>
                    <FeedbackList/>
                  </AdminLayout>
                  </React.Fragment>
                </PrivateRoute>
                } 
            />
                    
            {/* CONVERSATIONS */}
            <Route 
              path="/admin/conversations" 
              element={
              <PrivateRoute>
                <React.Fragment>
                <AdminLayout>
                  <Conversations/>
                </AdminLayout>
                </React.Fragment>
              </PrivateRoute>
              } 
            />
            <Route 
              path="/admin/conversations/:id" 
              element={
              <PrivateRoute>
                <React.Fragment>
                <AdminLayout>
                  <Conversation/>
                </AdminLayout>
                </React.Fragment>
              </PrivateRoute>
              } 
            />

          </Routes>
        </Router>
      </>
    )
  }
  
  export default Main